import { useEffect, useMemo, useRef } from 'react';
import { deriveLiveScenarios, tickMissiles } from '@/services/missile-engine';
import { useAppStore } from '@/stores/app-store';

// ---------------------------------------------------------------------------
// 100ms animation loop for missile trajectories
// 시나리오는 실시간 뉴스/Telegram/ACLED 데이터에서 도출 (missile-engine)
// ---------------------------------------------------------------------------

export function useMissileAnimation(enabled: boolean = true) {
  const setMissiles = useAppStore((s) => s.setMissiles);
  const newsItems = useAppStore((s) => s.news);
  const socialSignals = useAppStore((s) => s.socialSignals);
  const acledEvents = useAppStore((s) => s.acledEvents);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const scenarios = useMemo(
    () => deriveLiveScenarios(newsItems, socialSignals, acledEvents),
    [newsItems, socialSignals, acledEvents],
  );

  useEffect(() => {
    if (!enabled || scenarios.length === 0) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      setMissiles([]); // off 또는 감지된 실시간 이벤트 없음 → 미사일 없음
      return;
    }

    // Initial tick immediately
    setMissiles(tickMissiles(scenarios, Date.now()));

    intervalRef.current = setInterval(() => {
      setMissiles(tickMissiles(scenarios, Date.now()));
    }, 100);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [enabled, scenarios, setMissiles]);
}
